import { render, staticRenderFns } from "./enclosure.vue?vue&type=template&id=8486806a&scoped=true"
import script from "./enclosure.vue?vue&type=script&lang=js"
export * from "./enclosure.vue?vue&type=script&lang=js"
import style0 from "./enclosure.vue?vue&type=style&index=0&id=8486806a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8486806a",
  null
  
)

export default component.exports